import React from 'react';

const Sidebar = ({ activeTab, handleTabClick, isSidebarOpen }) => {
    return (
        <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
            <div className="tab-links">
                <button
                    className={activeTab === 'orders' ? 'active' : ''}
                    onClick={() => handleTabClick('orders')}
                >
                    Orders
                </button>
                {/* <button
                    className={activeTab === 'completed-orders' ? 'active' : ''}
                    onClick={() => handleTabClick('completed-orders')}
                >
                    Completed Orders
                </button> */}
                <button
                    className={activeTab === 'customers' ? 'active' : ''}
                    onClick={() => handleTabClick('customers')}
                >
                    Customers
                </button>
                <button
                    className={activeTab === 'analytics' ? 'active' : ''}
                    onClick={() => handleTabClick('analytics')}
                >
                    Analytics
                </button>
                <button
                    className={activeTab === 'buffet-bookings' ? 'active' : ''}
                    onClick={() => handleTabClick('buffet-bookings')}
                >
                    Buffet Bookings
                </button>
                {/* <button
                    className={activeTab === 'detty-december' ? 'active' : ''}
                    onClick={() => handleTabClick('detty-december')}
                >
                    Detty December
                </button> */}
                <button
                    className={activeTab === 'hall-rentals' ? 'active' : ''}
                    onClick={() => handleTabClick('hall-rentals')}
                >
                    Hall Rentals
                </button>
                <button
                    className={activeTab === 'items' ? 'active' : ''}
                    onClick={() => handleTabClick('items')}
                >
                    Instock Items
                </button>
                <button
                    className={activeTab === 'outofstock' ? 'active' : ''}
                    onClick={() => handleTabClick('outofstock')}
                >
                    Sold Out
                </button>
                <button
                    className={activeTab === 'categories' ? 'active' : ''}
                    onClick={() => handleTabClick('categories')}
                >
                    Categories
                </button>
                
            </div>
        </div>
    );
};

export default Sidebar;
